const featureFlags = {
  birthdayOffersEnabled: true,
};

export default featureFlags;
